import { GridRowHeightEnum } from "../../../@types/enumsGlobal";

const ImportedInvoiceItemGridPluginSettings: IPluginSettings = {
    name: "Позиции импортированной накладной",
    mnemocode: "imported_invoice_item_plugin",
    permission: "GlobalImportInvoices",
    rowHeight: GridRowHeightEnum.normal,
    columns: [
        {
            order: 0,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "IdGlobal",
            visibility: false,
            width: 150
        },
        {
            order: 1,
            propertyName: "goodsName",
            propertyType: "string",
            displayName: "Товар",
            visibility: true,
            width: 300
        },
        {
            order: 2,
            propertyName: "quantity",
            propertyType: "number",
            displayName: "Количество",
            visibility: true,
            width: 120
        },
        {
            order: 3,
            propertyName: "supplierPrice",
            propertyType: "decimal",
            displayName: "Цена поставщика",
            visibility: true,
            width: 150
        },
        {
            order: 4,
            propertyName: "sumIncVat",
            propertyType: "decimal",
            displayName: "Сумма с НДС",
            visibility: true,
            width: 150
        },
        {
            order: 5,
            propertyName: "supplierVat",
            propertyType: "decimal",
            displayName: "НДС",
            visibility: true,
            width: 100
        },
        {
            order: 6,
            propertyName: "producer",
            propertyType: "string",
            displayName: "Производитель",
            visibility: true,
            width: 200
        },
        {
            order: 7,
            propertyName: "country",
            propertyType: "string",
            displayName: "Страна",
            visibility: true,
            width: 150
        }
    ]
};

export default ImportedInvoiceItemGridPluginSettings;
